import axiosPrivate from "./axiosPrivate";

const getCapacitaciones = (params) => {
    return axiosPrivate.get("capacitaciones", { params })
        .then(response => response.data);
};

const insertCapacitacion = (data, archivoAsistencia, archivoEvidencia) => {
    const formData = new FormData();
    Object.entries(data).forEach(([key, value]) => {
        if (value !== null && value !== undefined) formData.append(key, value);
    });
    if (archivoAsistencia) formData.append('archivo_asistencia', archivoAsistencia);
    if (archivoEvidencia) formData.append('archivo_evidencia', archivoEvidencia);
    return axiosPrivate.post('capacitaciones', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    }).then(response => response.data);
};

const updateCapacitacion = (id, data, archivoAsistencia, archivoEvidencia) => {
    const formData = new FormData();
    formData.append('_method', 'PUT');
    Object.entries(data).forEach(([key, value]) => {
        if (value !== null && value !== undefined) formData.append(key, value);
    });
    if (archivoAsistencia) formData.append('archivo_asistencia', archivoAsistencia);
    if (archivoEvidencia) formData.append('archivo_evidencia', archivoEvidencia);
    return axiosPrivate.post(`capacitaciones/${id}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    }).then(response => response.data);
};

const deleteCapacitacion = (id, perfil_id) => {
    return axiosPrivate.delete(`capacitaciones/${id}`, { data: { perfil_id } })
        .then(response => response.data);
};

const subirAsistencia = (id, archivo, perfil_id, usuario_id) => {
    const formData = new FormData();
    formData.append("url_asistencia", archivo);
    formData.append("perfil_id", perfil_id);
    if (usuario_id !== undefined && usuario_id !== null) formData.append('usuario_id', usuario_id);
    return axiosPrivate.post(`capacitaciones/${id}/asistencia`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
    }).then(response => response.data);
};

const subirEvidencia = (id, archivo, perfil_id, usuario_id) => {
    const formData = new FormData();
    formData.append("url_evidencia", archivo);
    formData.append("perfil_id", perfil_id);
    if (usuario_id !== undefined && usuario_id !== null) formData.append('usuario_id', usuario_id);
    return axiosPrivate.post(`capacitaciones/${id}/evidencia`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
    }).then(response => response.data);
};

export default {
    getCapacitaciones,
    insertCapacitacion,
    updateCapacitacion,
    deleteCapacitacion,
    subirAsistencia,
    subirEvidencia,
};
